/**
 * @description Fonction pour slider de page intérieur
 * @param root {string}
 * @param type {string}
 * @param slidePerView {object}
 * @constructor
 */

/* eslint-disable no-unused-vars */
/* global bsBreakpoints */

const SliderInt = (
	root,
	type,
	slidePerView = { xl: 3, lg: 2, md: 2, sm: 1 }
) => {
	const $ = {
		root: root,
		slider: `data-slider-${type}`,
		slide: `slide-item`,
		dots: `slide-int-dots`,
		dot: `slide-int-dot`,
		next: 'slide-int-next',
		prev: 'slide-int-prev',
		skip: 'data-skip-slider',
		end: 'data-end-slider',
	};

	let thisSlide = 0;
	let maxSlide;
	let nbSlider;
	let breakpoint;
	let widgetId;
	let widgetIdValue;
	let posX1 = 0;
	let posX2 = 0;

	let bsBreakpoint = bsBreakpoints.detectBreakpoint();

	if (bsBreakpoint === 'xLarge') {
		breakpoint = 'xl';
	} else if (bsBreakpoint === 'large') {
		breakpoint = 'lg';
	} else if (bsBreakpoint === 'medium') {
		breakpoint = 'md';
	} else {
		breakpoint = 'sm';
	}

	// Gestion du touch

	/**
	 * @description Helper permettant de récuperer la valeur du translateX d'une slide
	 * @param myElement {slide à récupérer}
	 */

	 function getTranslateX(myElement) {
		const style = window.getComputedStyle(myElement);
		const matrix = new WebKitCSSMatrix(style.transform);
		return matrix.m41;
	}

	/**
	 * @description gestion du switch de dot active au touch
	 * @param direction {next ou prev}
	 * @param slideIndex {récupère l'index de la slide}
	 * @param getRoot {slider parent}
	 */
	const touchDots = (direction, slideIndex, getRoot) => {
		const dots = getRoot.querySelectorAll('.slide-int-dot');
		let applyIndex;
		direction === 'next' ? (applyIndex = -1) : (applyIndex = 1);
		dots.forEach((dot, index) => {
			index === slideIndex - applyIndex
				? dot.classList.add('active')
				: dot.classList.remove('active');
		});
	};

	const items = document.querySelectorAll(`.${$.slide}`);
	const dragStart = (e) => {
		if (e.type === 'touchstart') {
			posX1 = e.touches[0].clientX;
		} else {
			posX1 = e.clientX;
		}
	};
	const dragAction = (e) => {
		if (e.type === 'touchmove') {
			posX2 = e.touches[0].clientX;
		} else {
			posX2 = e.clientX;
		}
	};
	const dragEnd = (e) => {
		const slideTouched = e.target.closest('.slide-item'); // Permet de passer au dessus du strechted-link et récupérer l'élément slide
		let getindex;
		const root = slideTouched.closest(`[${$.slider}]`); // Récupère le slider parent
		const allSlides = root.querySelectorAll('.slide-item');
		let maxSlides = 0;
		let ratio = 0;
		const singleSlideWidth = slideTouched.offsetWidth; // Width d'une slide
		allSlides.forEach((slide, index) => {
			// On boucle et conditionne pour récupérer l'index de la slide touchée
			if (slideTouched === slide) {
				getindex = index;
			}
			// on incrémente maxSlides pour avoir la width globale
			maxSlides += slide.offsetWidth;
		});
		// Si l'action de swipe fait plus de 30px on gère le next
		if (posX2 - posX1 < -30) {
			ratio = singleSlideWidth * (getindex + 1); // On définit un ratio qui correspond à la taille d'une slide * l'index+1
			// Si ça dépasse pas la taille maximale, on applique un translate sur chque slide avec le ratio défini
			if (ratio < maxSlides) {
				allSlides.forEach((slide) => {
					slide.style.transform = `translateX(-${ratio}px)`;
				});
				touchDots('next', getindex, root);
			}
		}
		// Si l'action de swipe fait plus de 30px on gère le prev
		else if (posX2 - posX1 > 30) {
			const currentTranslate = getTranslateX(slideTouched); // On récupère la valeur du translate d'une slide
			ratio = currentTranslate + singleSlideWidth; // on définit le ratio
			if (ratio <= 0) {
				allSlides.forEach((slide) => {
					slide.style.transform = `translateX(${ratio}px)`;
				});
				touchDots('prev', getindex, root);
			}
		}
	};

	items.forEach((item) => {
		item.addEventListener('touchstart', dragStart);
		item.addEventListener('touchmove', dragAction);
		item.addEventListener('touchend', dragEnd);
	});

	/**
	 * @description A11Y du slider
	 * @param slider {number}
	 * @param thisSlide {number}
	 * @constructor
	 */
	const A11Y = (slider, thisSlide) => {
		const nbSlide = SlidePerView();
		const sliderEnd = thisSlide + nbSlide;

		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.slide}`)
			.forEach((item, index) => {
				if (index >= thisSlide && index < sliderEnd) {
					item.setAttribute('data-seen', true);
					item.setAttribute('aria-hidden', false);
				} else {
					item.setAttribute('data-seen', false);
					item.setAttribute('aria-hidden', true);
				}
			});

		document
			.querySelectorAll(
				`[${$.slider}='${slider}'] .${$.slide}[data-seen='true'] a`
			)
			.forEach((link) => {
				link.tabIndex = 0;
			});

		document
			.querySelectorAll(
				`[${$.slider}='${slider}'] .${$.slide}[data-seen='false'] a`
			)
			.forEach((link) => {
				link.tabIndex = -1;
			});

		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.dot}`)
			.forEach((dot) => {
				// eslint-disable-next-line no-unused-expressions
				dot.classList.contains('active')
					? dot.setAttribute('aria-current', true)
					: '';
			});
	};

	const ariaLabel = () => {
		widgetId = document.querySelectorAll('[data-slider-int]') || null;

		widgetId.forEach((item) => {
			widgetIdValue = item.querySelector('[data-slider-title]') || null;

			item.querySelectorAll(
				'button.slide-int-dot, button.slide-int-next, button.slide-int-prev'
			).forEach((el) => {
				// eslint-disable-next-line no-unused-expressions
				widgetIdValue.id
					? el.setAttribute('aria-describedby', widgetIdValue.id)
					: '';
			});
		});
	};

	/**
	 * @description Fonction pour skip le slider
	 * @param slider {number}
	 */
	const skipSlider = (slider) => {
		document
			.querySelector(`[${$.slider}='${slider}'] [${$.skip}]`)
			.addEventListener('click', () => {
				document
					.querySelector(`[${$.slider}='${slider}'] [${$.end}]`)
					.focus();
			});
	};

	/**
	 * @description Renvoie le numéro de slide actuel su slider
	 * @param slider {number}
	 * @returns {number}
	 * @constructor
	 */
	const ThisSlide = (slider) => {
		const activeDot = document.querySelector(
			`[${$.slider}='${slider}'] .${$.dot}.active`
		);
		let value;
		const hasValue = activeDot || null;

		if (hasValue) {
			value = activeDot.getAttribute('data-nb-slide');
		} else {
			value = 0;
		}

		return Number(value);
	};

	/**
	 * @description Renvoie le nombre de pixel du translate pour le slider
	 * @param slider {number}
	 * @returns {string}
	 */
	const translateSlide = (slider) => {
		const widthSlide = document.querySelector(
			`[${$.slider}='${slider}'] .${$.slide}`
		).scrollWidth;
		const translate = widthSlide * thisSlide;

		return `${translate}`;
	};

	/**
	 * @description Renvoie le nombre de slide par vue celon le breakpoint
	 * @returns {number}
	 * @constructor
	 */
	const SlidePerView = () => {
		return slidePerView[breakpoint];
	};

	/**
	 * @description Return le nombre de slide présent dans le slider
	 * @param slider {number}
	 * @returns {number}
	 * @constructor
	 */
	const MaxSlide = (slider) => {
		return document.querySelectorAll(
			`[${$.slider}='${slider}'] .${$.slide}`
		).length;
	};

	/**
	 * @description Identifie et numérote chaque slider de la page
	 */
	const multiSlider = () => {
		const sliders = document.querySelectorAll(`.${$.root}`);

		nbSlider = sliders.length;

		sliders.forEach((slide, index) => {
			const number = index.toString();
			slide.setAttribute($.slider, number);
		});
	};

	/**
	 * @description Affiche/cache les btn next//prev
	 * @param slider {number}
	 * @param thisSlide {number}
	 */
	const visibilityNextPrev = (slider, thisSlide) => {
		maxSlide = MaxSlide(slider);

		const nbPerView = SlidePerView();
		const btnSkip = document.querySelector(
			`[${$.slider}='${slider}'] [${$.skip}]`
		);
		const btnNext = document.querySelector(
			`[${$.slider}='${slider}'] .${$.next}`
		);
		const btnPrev = document.querySelector(
			`[${$.slider}='${slider}'] .${$.prev}`
		);

		if (maxSlide <= nbPerView) {
			btnSkip.style.visibility = 'hidden';
			btnPrev.tabIndex = -1;
			btnPrev.style.visibility = 'hidden';
			btnPrev.tabIndex = -1;
			btnNext.style.visibility = 'hidden';
			btnNext.tabIndex = -1;
		} else {
			btnSkip.style.visibility = 'inherit';
			btnPrev.tabIndex = 0;

			if (thisSlide === 0) {
				btnNext.style.visibility = 'inherit';
				btnNext.tabIndex = 0;
				btnPrev.style.visibility = 'hidden';
				btnPrev.tabIndex = -1;
			} else if (thisSlide === maxSlide - nbPerView) {
				btnPrev.style.visibility = 'inherit';
				btnPrev.tabIndex = 0;
				btnNext.style.visibility = 'hidden';
				btnNext.tabIndex = -1;
			} else {
				btnPrev.style.visibility = 'inherit';
				btnPrev.tabIndex = 0;
				btnNext.style.visibility = 'inherit';
				btnNext.tabIndex = 0;
			}
		}
	};

	/**
	 * @description Action à effectuer au click sur btn next//prev
	 * @param slider {number}
	 * @param btn {string}
	 * @param clickDot {number}
	 *
	 */
	const nav = (slider, btn = 'next', clickDot = null) => {
		thisSlide = ThisSlide(slider);

		if (clickDot || clickDot === 0) {
			thisSlide = clickDot;
		} else {
			if (btn === 'next') {
				if (thisSlide < maxSlide - 1) {
					thisSlide = thisSlide + 1;
				}
			} else {
				if (thisSlide > 0) {
					thisSlide = thisSlide - 1;
				}
			}
		}

		const translate = translateSlide(slider);

		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.slide}`)
			.forEach((item, index) => {
				item.style.transform = `translateX(-${translate}px)`;

				if (index < thisSlide) {
					item.style.opacity = '0';
					item.style.visibility = 'hidden';
				} else {
					item.style.visibility = 'inherit';
					item.style.opacity = '1';
				}
			});

		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.dot}`)
			.forEach((dot) => {
				if (dot.classList.contains('active')) {
					dot.classList.remove('active');
					dot.removeAttribute('aria-current');
				}
				if (
					dot.getAttribute('data-nb-slide') === thisSlide.toString()
				) {
					dot.classList.add('active');
					dot.setAttribute('aria-current', true);
				}
			});
		visibilityNextPrev(slider, thisSlide);
		A11Y(slider, thisSlide);
	};

	/**
	 * @description Action au click sur un dot
	 * @param slider {number}
	 * @constructor
	 */
	const ClickDot = (slider) => {
		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.dot}`)
			.forEach((dot) => {
				dot.addEventListener('click', () => {
					const thisDot = Number(dot.getAttribute('data-nb-slide'));

					nav(slider, 'next', thisDot);
					setTimeout(() => {
						document
						.querySelector(
							`[${$.slider}='${slider}'] .${$.slide}[data-seen='true'] a`
						)
						.focus();
					}, 500)
				});
			});
	};

	/**
	 * @description Mise en écoute des btn next//prev
	 */
	const navSlide = (slider) => {
		maxSlide = MaxSlide(slider);
		document
			.querySelector(`[${$.slider}='${slider}'] .${$.next}`)
			.addEventListener('click', (event) => {
				nav(slider, 'next');
			});

		document
			.querySelector(`[${$.slider}='${slider}'] .${$.prev}`)
			.addEventListener('click', () => {
				nav(slider, 'prev');
			});

		document
			.querySelector(`[${$.slider}='${slider}'] .${$.next}`)
			.addEventListener('keydown', (event) => {
				if (event.code === 'Enter') {
					event.preventDefault();
					nav(slider, 'next');
					if (bsBreakpoint === 'large' || bsBreakpoint === 'xLarge') {
						setTimeout(() => {
							document
								.querySelectorAll(
									`[${$.slider}='${slider}'] .${$.slide}[data-seen='true'] a`
								)[0]
								.focus();
						}, 100);
					}
				}
			});

		document
			.querySelector(`[${$.slider}='${slider}'] .${$.prev}`)
			.addEventListener('keydown', (event) => {
				if (event.code === 'Enter') {
					event.preventDefault();
					nav(slider, 'prev');
					if (bsBreakpoint === 'large' || bsBreakpoint === 'xLarge') {
						setTimeout(() => {
							document
								.querySelectorAll(
									`[${$.slider}='${slider}'] .${$.slide}[data-seen='true'] a`
								)[0]
								.focus();
						}, 100);
					}
				}
			});

		ClickDot(slider);
	};

	/**
	 * @description Conception des dotdot
	 * @param slider {number}
	 */
	const dotDot = (slider) => {
		maxSlide = MaxSlide(slider);

		const nbPerView = SlidePerView();
		const nbDot = maxSlide - nbPerView + 1;
		let content = ``;

		document.querySelector(
			`[${$.slider}='${slider}'] .${$.dots}`
		).innerHTML = '';

		if (maxSlide > nbPerView) {
			for (let i = 1; i <= nbDot; i++) {
				content += `<button type="button" tabindex="-1" class="slide-int-dot${
					i === 1 ? ` active` : ''
				}" data-nb-slide="${
					i - 1
				}"><span class="sr-only">${i}</span></button>`;
			}
		}

		document
			.querySelector(`[${$.slider}='${slider}'] .${$.dots}`)
			.insertAdjacentHTML('afterbegin', content);
	};

	/**
	 * @description Génération du slider intérieur
	 */
	const generate = () => {
		multiSlider();

		for (let i = 0; i < nbSlider; i++) {
			dotDot(i);
			visibilityNextPrev(i, thisSlide);
			A11Y(i, thisSlide);
			skipSlider(i);
			navSlide(i);
		}

		window.addEventListener('resize', () => {
			setTimeout(function () {
				bsBreakpoint = bsBreakpoints.getCurrentBreakpoint();
				if (bsBreakpoint === 'xLarge') {
					breakpoint = 'xl';
				} else if (bsBreakpoint === 'large') {
					breakpoint = 'lg';
				} else if (bsBreakpoint === 'medium') {
					breakpoint = 'md';
				} else {
					breakpoint = 'sm';
				}

				thisSlide = 0;
				if(document.querySelectorAll(`.${$.slide}`)){
					document.querySelectorAll(`.${$.slide}`).forEach((item) => {
						item.style.transform = `translateX(0)`;
						item.style.visibility = 'inherit';
						item.style.opacity = '1';
					});
				}
				

				for (let i = 0; i < nbSlider; i++) {
					dotDot(i);
					ClickDot(i);
					visibilityNextPrev(i, thisSlide);
				}
			}, 200);
		});

		window.addEventListener('load', () => {
			ariaLabel();
		});
	};

	generate();
};
